"use client";
import "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { styled } from "styled-components";
import { CpslButton, CpslIcon, CpslText } from "@getpara/react-components";
import { useModalStore } from "../../stores/index.js";
import { PARA_CONNECT, PARA_TERMS_AND_CONDITIONS } from "../../constants/constants.js";
import { useMemo } from "react";
import { getStepHasFooter } from "../../utils/steps.js";
const Footer = () => {
  const isAccount = useModalStore((state) => state.isAccount());
  const currentStep = useModalStore((state) => state.step);
  const showFooter = isAccount || getStepHasFooter(currentStep);
  const Content = useMemo(() => {
    if (isAccount) {
      return /* @__PURE__ */ jsxs(ConnectContainer, { children: [
        /* @__PURE__ */ jsxs(ConnectText, { variant: "bodyS", color: "secondary", weight: "medium", children: [
          "Access all your wallet\u2019s features at",
          " ",
          /* @__PURE__ */ jsx("a", { href: PARA_CONNECT, target: "blank", children: /* @__PURE__ */ jsx(ClickableText, { variant: "bodyS", weight: "medium", children: "Para Connect" }) })
        ] }),
        /* @__PURE__ */ jsx(CpslButton, { as: "a", href: PARA_CONNECT, target: "blank", variant: "ghost", children: /* @__PURE__ */ jsx(RightChevron, { icon: "chevronUp" }) })
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(InlineText, { variant: "body2XS", color: "secondary", weight: "medium", children: [
        "By logging in you agree to our",
        " ",
        /* @__PURE__ */ jsx("a", { href: PARA_TERMS_AND_CONDITIONS, target: "blank", children: /* @__PURE__ */ jsx(ClickableText, { variant: "body2XS", weight: "medium", children: "Terms & Conditions" }) })
      ] }),
      /* @__PURE__ */ jsxs(PoweredByContainer, { children: [
        /* @__PURE__ */ jsx(InlineText, { variant: "bodyS", color: "secondary", weight: "medium", children: "Powered by" }),
        /* @__PURE__ */ jsx(ParaLogo, { icon: "para" })
      ] })
    ] });
  }, [isAccount]);
  if (!showFooter) {
    return null;
  }
  return /* @__PURE__ */ jsx(FooterContainer, { slot: "footer", children: /* @__PURE__ */ jsx(FooterContentContainer, { children: Content }) });
};
const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0px;
`;
const FooterContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
const PoweredByContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;
const ConnectContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;
const RightChevron = styled(CpslIcon)`
  transform: rotate(90deg);

  /* --icon-color: var(--cpsl-color-text-tertiary); */
  --height: 24px;
  --width: 24px;
`;
const InlineText = styled(CpslText)`
  text-align: center;
  display: inline-block;
`;
const ConnectText = styled(InlineText)`
  line-height: 20px;
`;
const ClickableText = styled(InlineText)`
  cursor: pointer;
  display: inline-block;
`;
const ParaLogo = styled(CpslIcon)`
  display: inline-block;
  --icon-color: var(--cpsl-color-text-secondary);
  --width: 49px;
  --height: auto;
`;
export {
  Footer
};
